module.exports = __webpack_public_path__ + "static1/img/0aa7a6075da164bafc1c271af52c4e2.c1b4aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/0aa7a6075da164bafc1c271af52c4e2.png
// module id = fBqY
// module chunks = 1